import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const consentGiven = localStorage.getItem('cookieConsent');
    if (!consentGiven) {
      // Show the cookie consent banner after a small delay
      const timer = setTimeout(() => {
        setVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'true');
    setVisible(false);
  };

  const declineCookies = () => {
    // You might want to implement logic to disable non-essential cookies
    localStorage.setItem('cookieConsent', 'false');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <p>
          We use cookies to enhance your experience on our website. By clicking "Accept", 
          you agree to our use of cookies. 
          <Link to="/cookie-policy" className="cookie-link"> Learn more</Link>
        </p>
        <div className="cookie-buttons">
          <button onClick={declineCookies} className="decline-button">
            Decline
          </button>
          <button onClick={acceptCookies} className="accept-button">
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;